<template>
  <van-swipe
    class="inner-swiper"
    ref="inner-swiper2"
    :show-indicators="true"
    :initial-swipe="0"
    :style="`height: ${windowHeight};`"
  >
    <van-swipe-item>
      <div class="page2-6">
        <img
          class="logo"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
        />
        <img
          class="main-student"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/drum-student1.png"
        />
        <div class="main-title">爵士鼓</div>
        <div class="sub-title">DRUMS</div>
        <div class="common-video-button" @click="showVideo('drums')">
          <div class="border1"></div>
          <div class="border2"></div>
          <div class="border3"></div>
          <div class="content">
            <van-icon name="play" />
            <span class="text">查看视频</span>
          </div>
        </div>
        <div class="group-type">
          <img
            class="note1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note3.png"
          />
          <div class="item">
            <span class="dot"></span>
            <span class="text"
              >上课形式:<span class="num">3-6人</span>集体班</span
            >
          </div>
        </div>
        <div class="main-desc">
          <div class="title">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-longer.png"
            />
            <span class="text">爵士鼓原来那么有趣好玩</span>
          </div>
          <div class="desc">
            <span class="green"
              >爵士鼓课程制定专属训练模式、演奏标准,更注重音乐素质的培养</span
            >,让爵士鼓爱好者在通过课程系统训练后,能更好的学懂乐理知识、更熟练的掌握乐器演奏技法,为日后成为优秀的乐手打下良好的基础
          </div>
        </div>
        <div class="course-wrap">
          <img
            class="line"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-blue.png"
          />
          <div class="tag">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
            />
            <span class="text">课程优势</span>
          </div>
          <div class="list">
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon12.png"
              />
              <div class="text">
                <div class="title">易上手</div>
                <div class="desc">
                  根据孩子能力规划孩子每一个阶段、每一堂课的学习内容
                </div>
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon7.png"
              />
              <div class="text">
                <div class="title">曲目多样性</div>
                <div class="desc">
                  融入多种风格，感受不同律动，大型乐曲选自格莱美获奖曲目
                </div>
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon14.png"
              />
              <div class="text">
                <div class="title">专业性</div>
                <div class="desc">
                  专业性被专业院校教师认可的完整教材
                </div>
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon13.png"
              />
              <div class="text">
                <div class="title">智能教辅工具</div>
                <div class="desc">
                  每首练习曲和乐曲配有视频演示和音频伴奏,课后练习不再枯燥
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="result-wrap">
          <div class="tag">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
            />
            <span class="text">课程收获</span>
          </div>
          <div class="list">
            <div class="item">
              <van-icon name="success" />
              <span class="text">从对爵士鼓的认知到五大类风格的演奏</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">从单点演奏到手脚线性的进阶</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">从认识音符到节奏型以及填充的进阶</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">从基础律动循环到独奏SOLO的进阶</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">从启蒙到专业的进阶</span>
            </div>
          </div>
          <img
            class="bottom-img1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/drum-student2.png"
          />
          <img
            class="bottom-img2"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/drum-student3.png"
          />
        </div>
        <div class="bottom-arrow-wrap">
          <img
            class="bottom-line-red2"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-red3.png"
          />
          <div class="bottom-arrow-tips">
            <div class="red">滑动</div>
            <div>了解更多鼓教程</div>
          </div>
        </div>
      </div>
    </van-swipe-item>
    <van-swipe-item>
      <div class="page2-6 af-drum">
        <img
          class="logo"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
        />
        <img
          class="main-student"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/afd-student1.png"
        />
        <div class="main-title">非洲鼓</div>
        <div class="sub-title">AFRICAN DRUM</div>
        <div class="group-type">
          <img
            class="note1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note3.png"
          />
          <img
            class="note2"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note1.png"
          />
          <img
            class="note3"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note2.png"
          />
          <div class="item">
            <span class="dot"></span>
            <span class="text"
              >上课形式:<span class="num">3-6人</span>集体班</span
            >
          </div>
        </div>
        <div class="main-desc">
          <div class="title">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-longer.png"
            />
            <span class="text">启迪音乐的无限想象</span>
          </div>
          <div class="desc">
            音乐窝非洲鼓启蒙课程创新性运用色彩启发学习者想象力，以生动的音符、鲜艳的画面感以及故事的形式，激发孩子学习音乐的兴趣；课程中植入游戏环节，让孩子积极体验、参与富有非洲气氛的非洲鼓课堂
          </div>
        </div>
        <div class="course-wrap">
          <img
            class="line"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-blue2.png"
          />
          <div class="tag">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
            />
            <span class="text">课程优势</span>
          </div>
          <div class="list">
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon12.png"
              />
              <div class="text">
                <div class="title">非洲主题情景导入</div>
                <div class="desc">
                  以非洲风情的插画为主题，每首曲目都有不同的故事情景主题
                </div>
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon7.png"
              />
              <div class="text">
                <div class="title">渐进式知识点教学</div>
                <div class="desc">
                  以全音符、二分音符、四分音符、八分音符节奏为切入点进阶，简单易上手
                </div>
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon6.png"
              />
              <div class="text">
                <div class="title">趣味教材设计</div>
                <div class="desc">
                  以水果的姿态代替音符，增添趣味、呈现美感、加深记忆
                </div>
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon8.png"
              />
              <div class="text">
                <div class="title">同步乐队合奏</div>
                <div class="desc">
                  同步尤克里里教材曲库，增加合奏趣味性
                </div>
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon1.png"
              />
              <div class="text">
                <div class="title">完备的教辅工具</div>
                <div class="desc">
                  原创教辅音频、教辅视频、实体教材，让学习更具系统性
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="result-wrap">
          <div class="tag">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
            />
            <span class="text">课程收获</span>
          </div>
          <div class="list">
            <div class="item">
              <van-icon name="success" />
              <span class="text"
                >掌握全音符、二分音符、四分音符、四分休止符、八分音符、八分休止符</span
              >
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">快速识谱，乐曲分析</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">训练两肢体协调能力、训练乐感、节奏编排</span>
            </div>
          </div>
          <img
            class="bottom-img1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/afd-student2.png"
          />
        </div>
        <div class="bottom-arrow-wrap">
          <img
            class="bottom-line-red2"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-red3.png"
          />
          <div class="bottom-arrow-tips">
            <div class="red">滑动</div>
            <div>了解更多鼓教程</div>
          </div>
        </div>
      </div>
    </van-swipe-item>
  </van-swipe>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: "100vh",
    };
  },
  methods: {
    showVideo(type) {
      this.$emit("click-video", type);
    },
    swiperResize() {
      const isIos = !!navigator.userAgent.match(
        /\(i[^;]+;( U;)? CPU.+Mac OS X/
      ); //ios终端
      if (isIos) {
        this.windowHeight = window.innerHeight + "px";
      } else {
        this.windowHeight = "100vh";
      }
      this.$nextTick(() => {
        this.$refs["inner-swiper2"].resize();
      });
    },
  },
  mounted() {
    this.swiperResize();
    window.addEventListener("resize", this.swiperResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.swiperResize);
  },
};
</script>
<style scoped lang="scss">
@function perS($w) {
  @return ($w/375) * 100vw;
}
.inner-swiper {
  .van-swipe-item {
    height: 100%;
  }
}
.page2-6 {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100%;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/bg-light.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  &.af-drum {
    .main-student {
      width: perS(145);
      right: perS(40);
      top: 10vh;
    }
    .main-desc {
      .title {
        .img {
          width: perS(132);
        }
        .text {
          top: perS(9);
        }
      }
    }
    .group-type {
      margin-top: perS(40);
      .note1 {
        width: perS(50);
        height: auto;
        position: absolute;
        top: perS(-75);
        left: perS(280);
        z-index: 100;
        transform: rotate(35deg);
      }
      .note2 {
        width: perS(20);
        height: auto;
        position: absolute;
        top: perS(-15);
        left: perS(130);
        z-index: 100;
        transform: rotate(0);
      }
      .note3 {
        width: perS(24);
        height: auto;
        position: absolute;
        top: perS(140);
        left: perS(85);
        z-index: 100;
        transform: rotate(-20deg);
      }
    }
    .course-wrap {
      .line {
        width: perS(66);
        right: none;
        top: perS(-22);
        left: perS(-55);
      }
    }
    .result-wrap {
      margin-top: perS(6);
      .bottom-img1 {
        width: perS(132);
        top: perS(-27);
        right: perS(40);
      }
    }
  }
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 8vh;
    right: perS(28);
    z-index: 100;
  }
  .main-student {
    width: perS(650);
    height: auto;
    position: absolute;
    top: 11vh;
    right: perS(-170);
  }
  .main-title {
    position: relative;
    color: #46b13a;
    margin: 13vh 0 0 perS(25);
    font-size: perS(40);
    line-height: perS(40);
    font-weight: 900;
  }
  .sub-title {
    position: relative;
    color: #000;
    margin: 0 0 0 perS(25);
    font-size: perS(20);
    line-height: perS(20);
    font-weight: 900;
  }
  .group-type {
    margin: perS(8) 0 0 perS(25);
    position: relative;
    .note1 {
      width: perS(30);
      height: auto;
      position: absolute;
      top: perS(-80);
      left: perS(290);
      z-index: 100;
      transform: rotate(35deg);
    }
    .item {
      .dot {
        display: inline-block;
        width: perS(5);
        height: perS(5);
        border-radius: 50%;
        background-color: #46b13a;
        margin-right: perS(4);
      }
      .text {
        color: #000;
        font-size: perS(9);
        line-height: perS(23);
        font-weight: 500;
        .num {
          font-size: perS(12);
          font-weight: 700;
        }
      }
    }
  }
  .main-desc {
    position: relative;
    margin: perS(0) perS(25) 0 perS(25);
    .title {
      position: relative;
      .img {
        width: perS(157);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-8deg);
        position: absolute;
        top: perS(12.5);
        left: perS(7);
      }
    }
    .desc {
      background-color: #fff;
      margin: perS(-5) 0 0 0;
      padding: perS(10) perS(12);
      border-radius: perS(14);
      font-size: perS(8);
      line-height: perS(13);
      font-weight: 500;
      color: #000;
      box-shadow: 0 1px 2px #eee;
      .green {
        color: #46b13a;
        font-weight: 700;
      }
    }
  }
  .course-wrap {
    position: relative;
    margin: perS(18) perS(25) 0 perS(25);
    .line {
      position: absolute;
      right: perS(-34);
      top: perS(18);
      width: perS(77);
      height: auto;
    }
    .tag {
      position: relative;
      margin-bottom: perS(-5);
      .img {
        width: perS(70);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(6.5);
        left: perS(10);
      }
    }
    .list {
      padding: perS(12);
      border-radius: perS(14);
      background-color: #fff;
      box-shadow: 0 1px 2px #eee;
      .item {
        display: inline-flex;
        vertical-align: top;
        align-items: start;
        width: 50%;
        margin-bottom: perS(10);
        &:last-child {
          margin-bottom: 0;
        }
        .icon {
          width: perS(23);
          height: auto;
          margin-right: perS(4);
        }
        .text {
          .title {
            font-size: perS(13);
            font-weight: 900;
            line-height: perS(11);
            color: #000;
          }
          .desc {
            width: perS(100);
            font-size: perS(7);
            font-weight: 400;
            line-height: perS(10);
            color: #000;
            margin-top: perS(6);
          }
        }
      }
    }
  }
  .result-wrap {
    margin: perS(22) 0 0 perS(25);
    position: relative;
    .tag {
      position: relative;
      margin-bottom: perS(0);
      .img {
        width: perS(70);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(6.5);
        left: perS(10);
      }
    }
    .list {
      width: perS(172);
      .item {
        display: flex;
        .van-icon {
          margin-right: perS(8);
        }
        .text {
          font-size: perS(8);
          line-height: perS(16);
          font-weight: 500;
          color: #000;
          .green {
            color: #46b13a;
          }
        }
      }
    }
    .bottom-img1 {
      position: absolute;
      width: perS(105);
      height: auto;
      right: perS(80);
      top: perS(-15);
      z-index: 1;
    }
    .bottom-img2 {
      position: absolute;
      width: perS(101);
      height: auto;
      right: perS(5);
      top: perS(2);
      z-index: 1;
    }
  }
  .bottom-arrow-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: perS(65);
    animation: bottomArrowSwing 1.2s linear infinite;
    z-index: 1000;
    .bottom-line-red2 {
      position: absolute;
      width: perS(112);
      height: auto;
      right: perS(95);
      top: perS(0);
      z-index: 2;
    }
    .bottom-arrow-tips {
      font-size: perS(9);
      font-weight: 500;
      line-height: perS(14);
      color: #000;
      position: absolute;
      right: perS(14);
      top: perS(0);
      .red {
        font-size: perS(12);
        color: #d8654a;
        line-height: perS(11);
      }
    }
  }
}
@keyframes bottomArrowSwing {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(-2%, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@media screen and (max-height: 720px) {
  .page2-6 {
    .logo {
      top: 2vh;
    }
    .main-title {
      margin-top: 6vh;
    }
    .main-student {
      top: 5vh;
    }
    .bottom-arrow-wrap {
      bottom: 6vh;
    }
    .course-wrap {
      margin-top: 1vh;
    }
    &.af-drum {
      .main-student {
        top: 4vh;
      }
    }
  }
}
/deep/.van-swipe__indicator--active {
  background-color: #45b23a !important;
}
.common-video-button {
  display: inline-block;
  position: relative;
  padding: 10px;
  margin: perS(10) 0 0 perS(25);
  .border1 {
    border: 1px solid #ea5d40;
    border-radius: 16px;
    animation: 0.8s ease-in-out 0.6s videoBorderButtonFade infinite;
    position: absolute;
    top: 3px;
    left: 3px;
    width: 95px;
    height: 39px;
    display: none;
  }
  .border2 {
    border: 0.8px solid #ea5d40;
    border-radius: 15px;
    animation: 1s ease-in-out 0.3s videoBorderButtonFade infinite;
    position: absolute;
    top: 5px;
    left: 5px;
    width: 90px;
    height: 35px;
    display: none;
  }
  .border3 {
    border: 0.8px solid #ea5d40;
    border-radius: 14px;
    animation: 1s ease-in-out 0s videoBorderButtonFade infinite;
    position: absolute;
    top: 8px;
    left: 7px;
    width: 86px;
    height: 29px;
    display: none;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ea5d40;
    border-radius: 15px;
    width: 82px;
    height: 26px;
    animation: 1.5s ease-in-out 0s videoBorderButtonScale infinite;
    .van-icon {
      font-size: 12px;
      margin-right: 4px;
      color: #fff;
    }
    .text {
      color: #fff;
      font-size: 12px;
      line-height: 12px;
      font-weight: 700;
    }
  }
}
@keyframes videoBorderButtonScale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.2);
  }
  70% {
    transform: scale(1);
  }
  80% {
    transform: scale(1);
  }
  90% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes videoBorderButtonFade {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.6;
  }
}
</style>
